import React from "react";
import { Text, SettingsSelector, FrameIcon } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { config } from "../../../config/config";
import { DevicesWrapper, AccountStatusWrapper, TextDeviceManagementStyled, HeaderTextStyled } from "../styles/Styled";
import { resolution } from "./SettingConfig";

function parseDeviceName(deviceName) {
  return deviceName.replace("PlayStation4", config.get().sdk.deviceName);

}

export const Devices = ({ devices, onItemSelected }) => {
  return (
    <>
      {devices && (!devices.length || devices.length === 0) ? (
        <AccountStatusWrapper>
          <Text text={i18n.get("pages.settings.devices.notRegistered")} type="primary" size="xmedium" />
        </AccountStatusWrapper>
      ) : (
        <DevicesWrapper>
          <FrameIcon name="device" alignSelf="start" />
          <HeaderTextStyled rank="1" text={i18n.get(`pages.settings.menu.devices`)} size="large" />
          <TextDeviceManagementStyled
            rank="1"
            text={i18n.get(`pages.settings.devices.deviceManagement`)}
            type="greyLight"
            size="small"
          />
          <SettingsSelector
            items={devices.map(device => ({
              key: `key_${device.name}`,
              title: parseDeviceName(device.name.split("-")[0]),
              description: device.description,
              icon: "delete",
              active: true,
              id: device.id
            }))}
            onItemSelected={onItemSelected}
            selectedIndex={null}
            iconWidth={resolution?.devices.icon?.Width}
            iconHeight={resolution?.devices.icon?.Height}
            titleFontSize={resolution?.devices.title.FontSize}
            titleColor={resolution.devices.title.Color}
            descriptionFontSize={resolution.devices.description.FontSize}
            descriptionColor={resolution.devices.description.Color}
          />
        </DevicesWrapper>
      )}
    </>
  );
};
